import React, { useEffect, useState, useRef } from "react";
import "./Slideshow.css";

import Image1 from "../Images/Image1.jpeg";
import Image2 from "../Images/Image2.jpeg";
import Image3 from "../Images/Image3.jpeg";
import Image4 from "../Images/Image4.jpg";
import Image5 from "../Images/Image5.jpg";
import Image6 from "../Images/Image6.jpg";

const Bullet1 = process.env.PUBLIC_URL + "/Images/BullPoint1.svg";
const Bullet2 = process.env.PUBLIC_URL + "/Images/BullPoint2.svg";
const Bullet3 = process.env.PUBLIC_URL + "/Images/BullPoint3.svg";

const images = [Image1, Image2, Image3, Image4, Image5, Image6];
const bulletPoints = [Bullet1, Bullet2, Bullet3];

const Slideshow = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentBulletIndex, setCurrentBulletIndex] = useState(0);
  const [activeButton, setActiveButton] = useState(""); // Track active button
  const imageInterval = useRef(null);
  const bulletInterval = useRef(null);

  const resetTimers = () => {
    clearInterval(imageInterval.current);
    clearInterval(bulletInterval.current);

    // Start the image rotation timer
    imageInterval.current = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 2500);

    // Start the bullet point rotation timer
    bulletInterval.current = setInterval(() => {
      setCurrentBulletIndex(
        (prevIndex) => (prevIndex + 1) % bulletPoints.length
      );
      setActiveButton("next");
    }, 15000);
  };

  const handleNextBullet = () => {
    setCurrentBulletIndex((prevIndex) => (prevIndex + 1) % bulletPoints.length);
    setActiveButton("next");
    resetTimers();
  };

  const handlePrevBullet = () => {
    setCurrentBulletIndex(
      (prevIndex) => (prevIndex - 1 + bulletPoints.length) % bulletPoints.length
    );
    setActiveButton("prev");
    resetTimers();
  };

  useEffect(() => {
    resetTimers();

    return () => {
      clearInterval(imageInterval.current);
      clearInterval(bulletInterval.current);
    };
  }, []);

  useEffect(() => {
    if (activeButton) {
      const timer = setTimeout(() => {
        setActiveButton(""); // Remove highlight after animation
      }, 200);
      return () => clearTimeout(timer);
    }
  }, [activeButton]);

  return (
    <div className="slideshow-container">
      <div className="image-container">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Slide ${index + 1}`}
            className={`slide-image ${
              index === currentImageIndex ||
              index === (currentImageIndex + 1) % images.length
                ? "visible"
                : ""
            }`}
          />
        ))}
      </div>
      <div className="bullet-points">
        <div className="bullet-point">
          <img
            src={bulletPoints[currentBulletIndex]}
            alt={`Bullet Point ${currentBulletIndex + 1}`}
            className="bullet-shape"
          />
        </div>
        <div className="bullet-controls">
          <div className="button-wrapper">
            <button
              onClick={handlePrevBullet}
              className={`control-button prev-button ${
                activeButton === "prev" ? "active" : ""
              }`}
            >
              <svg viewBox="0 0 24 24" width="18" height="18">
                <path
                  d="M15 18l-6-6 6-6"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                />
              </svg>
            </button>
          </div>
          <div className="bullet-tracker">
            {bulletPoints.map((_, index) => (
              <span
                key={index}
                className={`tracker-number ${
                  index === currentBulletIndex ? "active" : ""
                }`}
              >
                {index + 1}
              </span>
            ))}
          </div>
          <div className="button-wrapper right">
            <button
              onClick={handleNextBullet}
              className={`control-button next-button ${
                activeButton === "next" ? "active" : ""
              }`}
            >
              <svg viewBox="0 0 24 24" width="18" height="18">
                <path
                  d="M9 18l6-6-6-6"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slideshow;
